import { ArrivalStatus } from '../../models/enum/arrival/arrival-status.enum';
import {
  MONITORING_ARRIVAL_CURRENT_DETAIL,
  MONITORING_ARRIVAL_HISTORY_DETAIL,
} from '../../../ui/constants/arrival/gate-monitoring';

export const currentMessage = (status: ArrivalStatus): string => {
  let statusMessage = '';
  switch (status) {
    case ArrivalStatus.GOING:
      statusMessage = MONITORING_ARRIVAL_CURRENT_DETAIL.STATUS_GOING;
      break;
    case ArrivalStatus.ARRIVED:
      statusMessage = MONITORING_ARRIVAL_CURRENT_DETAIL.STATUS_ARRIVED;
      break;
    case ArrivalStatus.RELEASED:
      statusMessage = MONITORING_ARRIVAL_CURRENT_DETAIL.STATUS_RELEASED;
      break;
    case ArrivalStatus.CANCELED:
      statusMessage = MONITORING_ARRIVAL_CURRENT_DETAIL.STATUS_CANCELED;
      break;
    default:
      '';
  }
  return statusMessage;
};

export const statusDescription = (
  status: ArrivalStatus,
  message: string,
  oldStatus?: ArrivalStatus,
  responsable?: boolean
): string => {
  let statusMessage = '';
  switch (status) {
    case ArrivalStatus.GOING:
      statusMessage = MONITORING_ARRIVAL_HISTORY_DETAIL.STATUS_GOING;
      break;
    case ArrivalStatus.UNPREDICTABLE:
      statusMessage =
        oldStatus === ArrivalStatus.UNPREDICTABLE
          ? MONITORING_ARRIVAL_HISTORY_DETAIL.USER_MESSAGE.concat(message)
          : message;
      break;
    case ArrivalStatus.ARRIVED:
      statusMessage = MONITORING_ARRIVAL_HISTORY_DETAIL.STATUS_ARRIVED;
      break;
    case ArrivalStatus.RELEASED:
      statusMessage = MONITORING_ARRIVAL_HISTORY_DETAIL.STATUS_RELEASED;
      break;
    case ArrivalStatus.CANCELED:
      statusMessage =
        oldStatus === ArrivalStatus.CANCELED
          ? MONITORING_ARRIVAL_HISTORY_DETAIL.USER_MESSAGE.concat(message)
          : MONITORING_ARRIVAL_HISTORY_DETAIL.STATUS_CANCELED;
      break;
    default:
      '';
  }
  return statusMessage;
};

export const userMessage = (message: string): string => {
  return MONITORING_ARRIVAL_HISTORY_DETAIL.USER_MESSAGE.concat(message);
};
